import { useTranslation } from 'libs/i18n'
import { useParams } from 'libs/router'
import { routes } from 'config/routes'
import { BackButton, Header, HistoryTable } from 'shared/components'
import { useFetchPayoutHistory } from './queries/useFetchPayoutHistory'

const PayoutHistoryPage = () => {
	const { t } = useTranslation()
	const params = useParams()
	const { payoutHistory, isPayoutHistoryLoading } = useFetchPayoutHistory()

	return (
		<>
			<Header
				title={t('Payout / History')}
				actions={<BackButton to={routes.payoutEdit(params.id)} />}
			/>
			<HistoryTable results={payoutHistory?.data} isLoading={isPayoutHistoryLoading} />
		</>
	)
}

export default PayoutHistoryPage
